import createAppRoot from 'coreReactRouter/createAppRoot';
import Document from 'coreReactRouter/Document';
import RootErrorBoundary from 'coreReactRouter/RootErrorBoundary';

import App from './components/_app';
import AppConfig from './components/_app-config';
import ErrorPage from './components/_error';

export const Layout = Document;

export const ErrorBoundary = RootErrorBoundary;

export default createAppRoot({AppConfig, App, ErrorPage});
